import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { API_url } from 'src/services/api.setup';
import { CityService } from 'src/services/regions/cityService';
import { AreaService } from 'src/services/regions/areaService';
import { CityModel } from 'src/models/regions/city';
import { AreaModel } from 'src/models/regions/area';
import { CarsModel } from 'src/models/cars/cars';
import CarsService from 'src/services/cars/carsServices';
import { AddressType } from 'src/models/customer/addressesModel';
import { BrandsModel } from 'src/models/cars/brands';
import { CarsCategoryModel } from 'src/models/cars/carsCategory';
import BrandsService from 'src/services/cars/brandsServices';
import CarCategoryService from 'src/services/cars/carCategoryServices';
import { FuelTypeModel } from 'src/models/customer/customerCarModel';
import { AppDispatch } from 'src/state/store';
import { useDispatch } from 'react-redux';
import { addAreasAsync, addCitiesAsync } from 'src/state/region/regionSlice';
import {
  CommunicationSubjectModel,
  CommunicationTypeModel
} from 'src/models/customer/communication';
import { ServiceModel } from 'src/models/services/service';
import { ServicesService } from 'src/services/service/serviceService';
import { TimeSlotServicess } from 'src/services/customer/timeSlotServices';
import { TimeSlotModel } from 'src/models/customer/timeSlotModel';
import { CountryModel } from 'src/models/regions/country';
import { StateModel } from 'src/models/regions/state';
import CountryService from 'src/services/regions/countryService';
import { StateService } from 'src/services/regions/stateService';
import { ServiceCategoryService } from 'src/services/service/serviceCategoryService';
import { ServiceCategoryModel } from 'src/models/services/serviceCategory';
import { ServiceTypeModel } from 'src/models/services/serviceType';
import { SOPModel } from 'src/models/services/sop';
import { MaterialModel } from 'src/models/services/material';
import { ServiceTypeService } from 'src/services/service/serviceTypeService';
import { SOPServices } from 'src/services/service/sOPServices';
import { MaterialsService } from 'src/services/service/materialsService';
import { UnitOfMeasureModel } from 'src/models/services/unitOfMeasure';
import { UnitOfMeasuresService } from 'src/services/service/UnitOfMeasuresService';
import { StatusesModel } from 'src/models/services/statuses';
import { StatusesService } from 'src/services/service/statusesService';
import { ServicePriceModel } from 'src/models/price/sevicePrice';
import { PackagePriceModel } from 'src/models/price/packagePrice';
import { PackagesModel } from 'src/models/package/packages';
import { ServicePriceServices } from 'src/services/price/servicePriceServices';
import { PackagePriceService } from 'src/services/price/packgePriceServices';
import { PackagesService } from 'src/services/package/packagesServices';
import PackagePrice from '../settings/price/packagePrices';
import { ServicePartnerModel } from 'src/models/servicePartner/servicePartnersModel';
import { BankAccountTypesModel } from 'src/models/servicePartner/backAccountModel';
import { ServicePartnerBankAccountsServices } from 'src/services/servicePartner/sPBankAccountsServices';
import { BookingsModel } from 'src/models/customer/bookingModel';
import { SubscriptionStatus } from 'src/models/subscription/subscriptionModel';
import SubscriptionServices from 'src/services/subscriptions/subscriptionServices';
import { useAuth } from 'src/contexts/AuthContext';

type CustomerContextValue = {
  customerAddressTypes: AddressType[];
  customerfuelType: FuelTypeModel[];
  communicationSubjectId: CommunicationSubjectModel[];
  communicationTypeId: CommunicationTypeModel[];
  allCountries: CountryModel[];
  activeCountries: CountryModel[];
  handleGetCountryData: (get?: string) => void;
  allState: StateModel[];
  activeState: StateModel[];
  handleGetStateData: (get?: string) => void;
  allCities: CityModel[];
  activeCities: CityModel[];
  handleGetCityData: (get?: string) => void;
  allAreas: AreaModel[];
  activeAreas: AreaModel[];
  handleGetAreaData: (get?: string) => void;
  allCars: CarsModel[];
  activeCars: CarsModel[];
  handleGetCarsData: (get?: string) => void;
  allBrands: BrandsModel[];
  activeBrands: BrandsModel[];
  handleGetBrandsData: (get?: string) => void;
  allCarCategory: CarsCategoryModel[];
  activeCarCategory: CarsCategoryModel[];
  handleGetCarCategoryData: (get?: string) => void;
  allServices: ServiceModel[];
  activeServices: ServiceModel[];
  handleGetServicesData: (get?: string) => void;
  allServiceCategory: ServiceCategoryModel[];
  activeServiceCategory: ServiceCategoryModel[];
  handleGetServiceCategory: (get?: string) => void;
  allServiceType: ServiceTypeModel[];
  activeServiceType: ServiceTypeModel[];
  handleGetServiceType: (get?: string) => void;
  allSOP: SOPModel[];
  activeSOP: SOPModel[];
  handleGetSOP: (get?: string) => void;
  allMaterial: MaterialModel[];
  activeMaterial: MaterialModel[];
  handleGetMaterial: (get?: string) => void;
  allStatuses: StatusesModel[];
  activeStatuses: StatusesModel[];
  handleGetStatuses: (get?: string) => void;
  allTimeSlots: TimeSlotModel[];
  allUnitOfMeasures: UnitOfMeasureModel[];
  activeUnitOfMeasures: UnitOfMeasureModel[];
  handleGetUnitOfMeasure: (get?: string) => void;
  allServicePrice: ServicePriceModel[];
  handleGetServicePrice: (get?: string) => void;
  allPackagePrice: PackagePriceModel[];
  handleGetPackagePrice: (get?: string) => void;
  allPackages: PackagesModel[];
  handleGetPackages: (get?: string) => void;
  handleAllServicePartnerData: (data: ServicePartnerModel[]) => void;
  allServicePatners: ServicePartnerModel[];
  activeServicePatners: ServicePartnerModel[];
  bankAccountTypes: BankAccountTypesModel[];
  bookingDataList: BookingsModel[];
  setBookingDataList: (data: BookingsModel[]) => void;
  allSubscriptionStatus: SubscriptionStatus[];
};

const CustomerContext = createContext<CustomerContextValue | undefined>(
  undefined
);

export function CustomerProvider({ children }) {
  const { token } = useAuth();
  const [hasFetchedData, setHasFetchedData] = useState(false);
  const isFetching = useRef(false)

  const [allServicePatners, setAllServicePatners] = useState<
    ServicePartnerModel[]
  >([]);
  const [activeServicePatners, setActiveServicePatners] = useState<
    ServicePartnerModel[]
  >([]);

  const [customerAddressTypes, setCustomerAddressTypes] = useState<
    AddressType[]
  >([]);
  const [customerfuelType, setCustomerfuelType] = useState<FuelTypeModel[]>([]);
  const [communicationSubjectId, setCommunicationSubjectId] = useState<
    CommunicationSubjectModel[]
  >([]);
  const [communicationTypeId, setCommunicationTypeId] = useState<
    CommunicationTypeModel[]
  >([]);
  const [allServices, setAllServices] = useState<ServiceModel[]>([]);
  const [activeServices, setActiveServices] = useState<ServiceModel[]>([]);
  const [allServiceCategory, setAllServiceCategory] = useState<
    ServiceCategoryModel[]
  >([]);
  const [activeServiceCategory, setActiveServiceCategory] = useState<
    ServiceCategoryModel[]
  >([]);
  const [allServiceType, setAllServiceType] = useState<ServiceTypeModel[]>([]);
  const [activeServiceType, setactiveServiceType] = useState<
    ServiceTypeModel[]
  >([]);
  const [allSOP, setAllSOP] = useState<SOPModel[]>([]);
  const [activeSOP, setActiveSOP] = useState<SOPModel[]>([]);
  const [allMaterial, setAllMaterial] = useState<MaterialModel[]>([]);
  const [activeMaterial, setActiveMaterial] = useState<MaterialModel[]>([]);
  const [allUnitOfMeasures, setAllUnitOfMeasures] = useState<
    UnitOfMeasureModel[]
  >([]);
  const [activeUnitOfMeasures, setActiveUnitOfMeasures] = useState<
    UnitOfMeasureModel[]
  >([]);
  const [allStatuses, setAllStatuses] = useState<StatusesModel[]>([]);
  const [activeStatuses, setActiveStatuses] = useState<StatusesModel[]>([]);
  const [allCountries, setAllCountries] = useState<CountryModel[]>([]);
  const [activeCountries, setActiveCountries] = useState<CountryModel[]>([]);
  const [allState, setAllState] = useState<StateModel[]>([]);
  const [activeState, setActiveState] = useState<StateModel[]>([]);
  const [allCities, setAllCities] = useState<CityModel[]>([]);
  const [activeCities, setActiveCities] = useState<CityModel[]>([]);
  const [allAreas, setAllAreas] = useState<AreaModel[]>([]);
  const [activeAreas, setActiveAreas] = useState<AreaModel[]>([]);
  const [allCars, setAllCars] = useState<CarsModel[]>([]);
  const [activeCars, setActiveCars] = useState<CarsModel[]>([]);
  const [allBrands, setAllBrands] = useState<BrandsModel[]>([]);
  const [activeBrands, setActiveBrands] = useState<BrandsModel[]>([]);
  const [allCarCategory, setAllCarCategory] = useState<CarsCategoryModel[]>([]);
  const [activeCarCategory, setActiveCarCategory] = useState<
    CarsCategoryModel[]
  >([]);
  const [allTimeSlots, setAllTimeSlots] = useState<TimeSlotModel[]>();
  const [allServicePrice, setAllServicePrice] = useState<ServicePriceModel[]>();
  const [allPackagePrice, setAllPackagePrice] = useState<PackagePriceModel[]>();
  const [allPackages, setAllPackages] = useState<PackagesModel[]>();
  const [GotDataOf, setGotDataOf] = useState([]);
  const [bankAccountTypes, setBankAccountTypes] = useState<
    BankAccountTypesModel[]
  >([]);
  const [allSubscriptionStatus, setAllSubscriptionStatus] = useState<SubscriptionStatus[]>([]);
  const [bookingDataList, setBookingDataList] = useState<BookingsModel[]>([]);
  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!token) {
          setHasFetchedData(false);
          return;
        }

        if (token && !hasFetchedData) {
          const customerAddressTypes = await axios.get(
            `${API_url}/customeraddresses/getCustomerAddressTypes`
          );
          const customerfuelType = await axios.get(
            `${API_url}/cars/getAllFuelTypes`
          );
          const communicationSubjectId = await axios.get(
            `${API_url}/CommunicationSubject/GetAllCommunicationSubject`
          );
          const communicationTypeId = await axios.get(
            `${API_url}/CustomerCommunication/getAllCommunicationTypes`
          );

          const accountsType =
            await ServicePartnerBankAccountsServices.getBankAccountTypes();

          const allCountriesGet: CountryModel[] =
            await CountryService.getAllCountries();
          const ACountry: CountryModel[] = allCountriesGet.filter(
            (x) => x.status === true
          );
          const allState: StateModel[] = await StateService.getAllState();
          const AState: StateModel[] = allState.filter((x) => x.status === true);
          const allCities: CityModel[] = await CityService.getAllCity();
          const ACities: CityModel[] = allCities.filter((x) => x.status === true);
          const timeSlots = await TimeSlotServicess.getData();
          const allAreas = await AreaService.getAllArea();
          const AAreas: AreaModel[] = allAreas.filter((x) => x.status === true);
          const allCars = await CarsService.getAllCars();
          const ACars: CarsModel[] = allCars.filter((x) => x.status === true);
          const allBrands = await BrandsService.getAllBrands();
          const ABrands: BrandsModel[] = allBrands.filter(
            (x) => x.status === true
          );
          const allServices = await ServicesService.getAllServices();
          const AServices: ServiceModel[] = allServices.filter(
            (x) => x.status === true
          );
          const allServiceCategory =
            await ServiceCategoryService.getAllServiceCategory();
          const AServiceCategory: ServiceCategoryModel[] =
            allServiceCategory.filter((x) => x.status === true);

          const allServiceType = await ServiceTypeService.getAllServiceType();
          const AServiceType: ServiceTypeModel[] = allServiceType.filter(
            (x) => x.status === true
          );
          const allSOP = await SOPServices.getAllData();
          const ASOP: SOPModel[] = allSOP.filter((x) => x.status === true);
          const allMaterial = await MaterialsService.getAllData();
          const AMatreial: MaterialModel[] = allMaterial.filter(
            (x) => x.status === true
          );
          const allCarCategory = await CarCategoryService.getAllCarCategory();
          const ACarCategory: CarsCategoryModel[] = allCarCategory.filter(
            (x) => x.status === true
          );
          const allUnitOfMeasures = await UnitOfMeasuresService.getAllData();
          const AUnitOfMeasure: UnitOfMeasureModel[] = allUnitOfMeasures.filter(
            (x) => x.status === true
          );
          const allStatuses = await StatusesService.getAllData();
          const AStatuses: StatusesModel[] = allStatuses.filter(
            (x) => x.isActive === true
          );
          const allServicePrice = await ServicePriceServices.getAllData();
          const allPackagePrice = await PackagePriceService.getAllData();
          const allPackages = await PackagesService.getAllData();
          const allSubscriptionStatusData = await SubscriptionServices.getAllSubscriptionStatus();
          setAllTimeSlots(timeSlots);
          setBankAccountTypes(accountsType);
          setCustomerAddressTypes(customerAddressTypes.data);
          setCustomerfuelType(customerfuelType.data);
          setCommunicationSubjectId(communicationSubjectId.data);
          setCommunicationTypeId(communicationTypeId.data);
          setCustomerfuelType(customerfuelType.data);
          setAllCountries(allCountriesGet);
          setActiveCountries(ACountry);
          setAllSubscriptionStatus(allSubscriptionStatusData);
          setGotDataOf((prevData) => [
            ...new Set([
              ...prevData,
              'Country',
              'State',
              'City',
              'Area',
              'Cars',
              'Brands',
              'CarCategory',
              'Services',
              'ServiceCategory',
              'ServiceType',
              'SOP',
              'Materail',
              'UnitOfMeasure',
              'Statuses',
              'ServicePrice',
              'PackagePrice',
              'Packages'
            ])
          ]);
          setAllState(allState);
          setActiveState(AState);
          setAllCities(allCities);
          setActiveCities(ACities);
          setAllAreas(allAreas);
          setActiveAreas(AAreas);
          dispatch(addAreasAsync());
          dispatch(addCitiesAsync());
          setAllCars(allCars);
          setActiveCars(ACars);
          setAllBrands(allBrands);
          setActiveBrands(ABrands);
          setAllServices(allServices);
          setActiveServices(AServices);
          setAllServiceCategory(allServiceCategory);
          setActiveServiceCategory(AServiceCategory);
          setAllSOP(allSOP);
          setActiveSOP(ASOP);
          setAllServiceType(allServiceType);
          setactiveServiceType(activeServiceType);
          setAllMaterial(allMaterial);
          setActiveMaterial(AMatreial);
          setAllUnitOfMeasures(allUnitOfMeasures);
          setActiveUnitOfMeasures(AUnitOfMeasure);
          setAllStatuses(allStatuses);
          setActiveStatuses(AStatuses);
          setAllCarCategory(allCarCategory);
          setActiveCarCategory(ACarCategory);
          setAllServicePrice(allServicePrice);
          setAllPackagePrice(allPackagePrice);
          setAllPackages(allPackages);
          setHasFetchedData(true);
        }
      } catch (error) {
        console.error('Error fetching customer address types:', error);
      }
    };

    fetchData();
  }, [token]);

  const handleGetCountryData = async (get?) => {
    if (!GotDataOf.includes('Country') || get === 'Get') {
      const allCountriesGet: CountryModel[] =
        await CountryService.getAllCountries();
      const ACountry: CountryModel[] = allCountriesGet.filter(
        (x) => x.status === true
      );

      setAllCountries(allCountriesGet);
      setActiveCountries(ACountry);
      setGotDataOf((prevData) => [...new Set([...prevData, 'Country'])]);
    }
    const data = allCountries;
  };

  const handleGetStateData = async (get?) => {
    if (!GotDataOf.includes('State') || get === 'Get') {
      const allStatesGet: StateModel[] = await StateService.getAllState();
      const AState: StateModel[] = allStatesGet.filter(
        (x) => x.status === true
      );

      setAllState(allStatesGet);
      setActiveState(AState);
      setGotDataOf((prevData) => [...new Set([...prevData, 'State'])]);
    }
  };

  const handleGetCityData = async (get?) => {
    if (!GotDataOf.includes('City') || get === 'Get') {
      const allCitiesGet: CityModel[] = await CityService.getAllCity();
      const ACity: CityModel[] = allCitiesGet.filter((x) => x.status === true);

      setAllCities(allCitiesGet);
      setActiveCities(ACity);
      setGotDataOf((prevData) => [...new Set([...prevData, 'City'])]);

      return allCities
    }
  };

  const handleGetAreaData = async (get?) => {
    if (!GotDataOf.includes('Area') || get === 'Get') {
      const allAreasGet: AreaModel[] = await AreaService.getAllArea();
      const AArea: AreaModel[] = allAreasGet.filter((x) => x.status === true);

      setAllAreas(allAreasGet);
      setActiveAreas(AArea);
      setGotDataOf((prevData) => [...new Set([...prevData, 'Area'])]);
    }
  };

  const handleGetCarsData = async (get?) => {
    if (!GotDataOf.includes('Cars') || get === 'Get') {
      const AllCarsGet: CarsModel[] = await CarsService.getAllCars();
      const ACars: CarsModel[] = AllCarsGet.filter((x) => x.status === true);

      setAllCars(AllCarsGet);
      setActiveCars(ACars);
      setGotDataOf((prevData) => [...new Set([...prevData, 'Cars'])]);
    }
  };

  const handleGetBrandsData = async (get?) => {
    if (!GotDataOf.includes('Brands') || get === 'Get') {
      const AllBrandsGet: BrandsModel[] = await BrandsService.getAllBrands();
      const ABrands: BrandsModel[] = AllBrandsGet.filter(
        (x) => x.status === true
      );

      setAllBrands(AllBrandsGet);
      setActiveBrands(ABrands);
      setGotDataOf((prevData) => [...new Set([...prevData, 'Brands'])]);
    }
  };

  const handleGetCarCategoryData = async (get?) => {
    if (!GotDataOf.includes('CarCategory') || get === 'Get') {
      const AllCarCategoryGet: CarsCategoryModel[] =
        await CarCategoryService.getAllCarCategory();
      const ACarCategory: CarsCategoryModel[] = AllCarCategoryGet.filter(
        (x) => x.status === true
      );

      setAllCarCategory(AllCarCategoryGet);
      setActiveCarCategory(ACarCategory);
      setGotDataOf((prevData) => [...new Set([...prevData, 'CarCategory'])]);
    }
  };

  const handleGetServicesData = async (get?) => {
    if (!GotDataOf.includes('Services') || get === 'Get') {
      const AllServicesGet: ServiceModel[] =
        await ServicesService.getAllServices();
      const AServices: ServiceModel[] = AllServicesGet.filter(
        (x) => x.status === true
      );

      setAllServices(AllServicesGet);
      setActiveServices(AServices);
      setGotDataOf((prevData) => [...new Set([...prevData, 'Services'])]);
    }
  };

  const handleGetServiceCategory = async (get?) => {
    if (!GotDataOf.includes('ServiceCategory') || get === 'Get') {
      const AllServiceCategoryGet: ServiceCategoryModel[] =
        await ServiceCategoryService.getAllServiceCategory();
      const AServiceCategory: ServiceCategoryModel[] =
        AllServiceCategoryGet.filter((x) => x.status === true);
      setAllServiceCategory(AllServiceCategoryGet);
      setActiveServiceCategory(AServiceCategory);
      setGotDataOf((prevData) => [
        ...new Set([...prevData, 'ServiceCategory'])
      ]);
    }
  };

  const handleGetServiceType = async (get?) => {
    if (!GotDataOf.includes('ServiceType') || get === 'Get') {
      const AllServiceTypeGet: ServiceTypeModel[] =
        await ServiceTypeService.getAllServiceType();
      const AServiceType: ServiceTypeModel[] = AllServiceTypeGet.filter(
        (x) => x.status === true
      );
      setAllServiceType(AllServiceTypeGet);
      setactiveServiceType(AServiceType);
      setGotDataOf((prevData) => [...new Set([...prevData, 'ServiceType'])]);
    }
  };

  const handleGetSOP = async (get?) => {
    if (!GotDataOf.includes('SOP') || get === 'Get') {
      const AllSOPGet: SOPModel[] = await SOPServices.getAllData();
      const ASOP: SOPModel[] = AllSOPGet.filter((x) => x.status === true);

      setAllSOP(AllSOPGet);
      setActiveSOP(ASOP);
      setGotDataOf((prevData) => [...new Set([...prevData, 'SOP'])]);
    }
  };

  const handleGetMaterial = async (get?) => {
    if (!GotDataOf.includes('Materail') || get === 'Get') {
      const AllMaterailGet: MaterialModel[] =
        await MaterialsService.getAllData();
      const AMaterail: MaterialModel[] = AllMaterailGet.filter(
        (x) => x.status === true
      );

      setAllMaterial(AllMaterailGet);
      setActiveMaterial(AMaterail);
      setGotDataOf((prevData) => [...new Set([...prevData, 'Materail'])]);
    }
  };

  const handleGetUnitOfMeasure = async (get?) => {
    if (!GotDataOf.includes('UnitOfMeasure') || get === 'Get') {
      const AllUnitOfMeasureGet: UnitOfMeasureModel[] =
        await UnitOfMeasuresService.getAllData();
      const AUnitOfMeasure: UnitOfMeasureModel[] = AllUnitOfMeasureGet.filter(
        (x) => x.status === true
      );

      setAllUnitOfMeasures(AllUnitOfMeasureGet);
      setActiveUnitOfMeasures(AUnitOfMeasure);
      setGotDataOf((prevData) => [...new Set([...prevData, 'UnitOfMeasure'])]);
    }
  };

  const handleGetStatuses = async (get?) => {
    if (!GotDataOf.includes('Statuses') || get === 'Get') {
      const AllStatuses: StatusesModel[] = await StatusesService.getAllData();
      const AStatuses: StatusesModel[] = AllStatuses.filter(
        (x) => x.isActive === true
      );

      setAllStatuses(AllStatuses);
      setActiveStatuses(AStatuses);
      setGotDataOf((prevData) => [...new Set([...prevData, 'Statuses'])]);
    }
  };

  const handleGetServicePrice = async (get?) => {
    if (!GotDataOf.includes('ServicePrice') || get === 'Get') {
      const AllServicePrice: ServicePriceModel[] =
        await ServicePriceServices.getAllData();
      // const AServicePrice: ServicePriceModel[] = AllServicePrice.filter(
      //   (x) => x.IsActive === true
      // );

      setAllServicePrice(AllServicePrice);
      // setActiveServicePrice(AServicePrice);
      setGotDataOf((prevData) => [...new Set([...prevData, 'ServicePrice'])]);
    }
  };

  const handleGetPackagePrice = async (get?) => {
    if (!GotDataOf.includes('PackagePrice') || get === 'Get') {
      const AllPackagePrice: PackagePriceModel[] =
        await PackagePriceService.getAllData();

      setAllPackagePrice(AllPackagePrice);

      setGotDataOf((prevData) => [...new Set([...prevData, 'PackagePrice'])]);
    }
  };

  const handleGetPackages = async (get?) => {
    if (!GotDataOf.includes('Packages') || get === 'Get') {
      const AllPackages: PackagesModel[] = await PackagesService.getAllData();

      setAllPackages(AllPackages);

      setGotDataOf((prevData) => [...new Set([...prevData, 'Packages'])]);
    }
  };

  const handleAllServicePartnerData = (data: ServicePartnerModel[]) => {
    const activeData = data.filter((item) => item.isActive === true);

    setAllServicePatners(data);
    setActiveServicePatners(activeData);
  };

  return (
    <CustomerContext.Provider
      value={{
        customerAddressTypes,
        communicationSubjectId,
        communicationTypeId,
        customerfuelType,
        allTimeSlots,
        activeCountries,
        allCountries,
        handleGetCountryData,
        allCities,
        activeCities,
        handleGetCityData,
        allState,
        activeState,
        handleGetStateData,
        allAreas,
        activeAreas,
        handleGetAreaData,
        allCars,
        activeCars,
        handleGetCarsData,
        allBrands,
        activeBrands,
        handleGetBrandsData,
        allServices,
        activeServices,
        handleGetServicesData,
        allServiceCategory,
        activeServiceCategory,
        handleGetServiceCategory,
        allServiceType,
        activeServiceType,
        handleGetServiceType,
        allSOP,
        activeSOP,
        handleGetSOP,
        allMaterial,
        activeMaterial,
        handleGetMaterial,
        allCarCategory,
        activeCarCategory,
        allUnitOfMeasures,
        activeUnitOfMeasures,
        handleGetUnitOfMeasure,
        allStatuses,
        activeStatuses,
        handleGetStatuses,
        handleGetCarCategoryData,
        allServicePrice,
        handleGetServicePrice,
        allPackagePrice,
        handleGetPackagePrice,
        allPackages,
        handleGetPackages,
        handleAllServicePartnerData,
        allServicePatners,
        activeServicePatners,
        bankAccountTypes,
        setBookingDataList,
        bookingDataList,
        allSubscriptionStatus
      }}
    >
      {children}
    </CustomerContext.Provider>
  );
}

export const useCustomerData = (): CustomerContextValue => {
  const context = useContext(CustomerContext);
  if (!context) {
    throw new Error('useCustomerData must be used within a CustomerProvider');
  }
  return context;
};

export default CustomerContext;
